<template>
  <div>
    <div class="title-bar detail clearfix">
      <div class="module pull-left">
        {{ $t("user.addUser") }}
      </div>
      <div class="btn-group pull-right">
        <el-button :plain="true" type="primary" size="mini" @click="addUser('addUserForm')">{{ $t("save") }}
        </el-button>
        <el-button :plain="true" size="mini" @click="cancelOperation()">{{ $t("cancel") }}
        </el-button>
      </div>
    </div>

    <div class="data-list detail">
      <div class="detail-header">
        <span>用户信息</span>
        <div class="detail-triangle"></div>
      </div>
      <div class="detail-content">
        <el-form class="detail-form" ref="addUserForm" :model="userInfo" :rules="rules" status-icon size="small" label-width="100px">
          <el-row>
            <el-col :xs="24" :sm="12" :md="12" :lg="12">
              <el-form-item :label="this.$t('user.email')" prop="email">
                <el-input v-model="userInfo.email"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="12">
              <el-form-item :label="this.$t('user.rolesPlaceholder')" prop="userRoles">
                <el-select v-model="userInfo.userRoles">
                  <el-option v-for="role in rolesList" :key="role.value" :label="$t(`user.roles.${role.Name}`)" :value="role.Name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :sm="12" :md="12" :lg="12">
              <el-form-item :label="this.$t('user.name')" prop="name">
                <el-input v-model="userInfo.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="12">
              <el-form-item :label="this.$t('user.phoneNumber')" prop="phoneNumber">
                <el-input v-model="userInfo.phoneNumber"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :sm="12" :md="12" :lg="12">
              <el-form-item :label="this.$t('user.password')" prop="password">
                <div @keyup="handlekeyup($event)">
                  <el-input type="password" v-model="userInfo.password" auto-complete="off"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="12">
              <el-form-item :label="this.$t('user.confirmPassword')" prop="confirmPassword">
                <div id="confirmpwd">
                  <el-input type="password" v-model="userInfo.confirmPassword" auto-complete="off"></el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddUser",
  data() {
    var confirmPassword = (rule, value, callback) => {
      if (value !== this.userInfo.password) {
        callback(new Error(this.$t("user.confirmPasswordSameValidation")));
      } else {
        callback();
      }
    };

    return {
      userInfo: {
        email: "",
        name: "",
        username: "",
        phoneNumber: "",
        confirmPassword: "",
        userRoles: []
      },
      rolesList: [],
      rules: {
        name: [
          {
            required: true,
            message: this.$t("user.nameValidation")
          }
        ],
        email: [
          {
            required: true,
            message: this.$t("user.emailValidation")
          },
          {
            type: "email",
            message: this.$t("user.emailFormatValidation"),
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: this.$t("user.passwordValidation")
          },
          {
            min: 6,
            message: this.$t("user.pvalid.minLen", { len: 6 }),
            trigger: "blur"
          },
          {
            pattern: new RegExp(/[A-Z]/),
            message: this.$t("user.pvalid.oneUppercase"),
            trigger: "blur"
          },
          {
            pattern: new RegExp(/[a-z]/),
            message: this.$t("user.pvalid.oneLowercase"),
            trigger: "blur"
          },
          {
            pattern: new RegExp(/[0-9]/),
            message: this.$t("user.pvalid.oneDigit"),
            trigger: "blur"
          },
          {
            pattern: new RegExp(/[^a-zA-Z0-9]/),
            message: this.$t("user.pvalid.oneNonLetterOrDigit"),
            trigger: "blur"
          }
        ],
        confirmPassword: [
          {
            required: true,
            message: this.$t("user.confirmPasswordRequiredValidation")
          },
          { validator: confirmPassword }
        ],
        userRoles: [
          { required: true, message: this.$t("user.userRolesValidation") }
        ],

        phoneNumber: [
          {
            validator: (rule, value, callback) => {
              var raw = JSON.stringify(value).replace(/\"/g, "");
              if (raw == "" || raw == null || raw == undefined) {
                callback();
              }
              var format = raw.replace(/[^0-9+]/g, "");

              if (
                (raw.length != 14 && raw.length != 11) ||
                (raw.length == 14 && raw.charAt(0) != "+") ||
                raw.substring(1, raw.length).includes("+") ||
                raw.length > format.length
              ) {
                callback(new Error("请输入正确的手机号码"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.$axios.get("api/Roles").then(response => {
      this.rolesList = response.data;
    });
  },
  methods: {
    handlekeyup(event) {
      var father = event.currentTarget;
      var confirm = document
        .getElementById("confirmpwd")
        .getElementsByTagName("input")[0];
      var obj = father.getElementsByTagName("input")[0];
      if (obj.value === this.userInfo.confirmPassword) {
        confirm.focus();
        obj.focus();
      }
    },
    goBack() {
      this.$router.push({ name: "UserManagement" });
    },
    addUser(addUserForm) {
      this.$refs[addUserForm].validate(valid => {
        if (valid) {
          this.$axios
            .post("api/Users", this.userInfo)
            .then(response => {
              this.$message({
                message: this.$t("user.userAddedSuccessfully"),
                type: "success",
                showClose: true,
                duration: 2000
              });
              this.goBack();
            })
            .catch(e => {
              let msg = this.$t("user.operationFailure");
              if (e.response) {
                var errorMsg = e.response.data.ExceptionMessage || e.response.data;
                if (errorMsg === "DuplicateUser") {
                  msg = this.$t("user.DuplicateUser");
                } else if (e.response.data.ModelState) {
                  msg = Object.values(e.response.data.modelState).join();
                }
              }
              this.$message({
                message: msg,
                type: "error"
              });
            });
        }
      });
    },
    cancelOperation() {
      this.goBack();
    }
  }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/application/UserManagement/AddUser.vue